import Vue from "vue";
import {
  Button,
  Popup,
  Icon,
  Image as VanImage,
  Notify,
  Cell,
  List,
  NavBar,
  Loading,
  Tabbar,
  TabbarItem,
  Progress,
  Checkbox,
  Overlay,
  Dialog
} from "vant";

import AdsenseUnit from "@/components/AdsenseUnit";

export function initVantComponents() {
  Vue.use(Notify);
  Vue.use(Button);
  Vue.use(Icon);
  Vue.use(VanImage);
  Vue.use(Popup);
  Vue.use(Cell);
  Vue.use(List);
  Vue.use(NavBar);
  Vue.use(Loading);
  Vue.use(Tabbar);
  Vue.use(TabbarItem);
  Vue.use(Progress);
  Vue.use(Checkbox);
  Vue.use(Overlay);
  Vue.use(Dialog);

  // app
  Vue.component(AdsenseUnit.name, AdsenseUnit);
}

const baseStyle = `padding: 2px; border-radius: 2px;color: white;`;

export function initDataRanger() {
  if (process.env.NODE_ENV === "development") {
    window.$event = (eve, param) => {
      // eslint-disable
      console.info(
        `%c record event %c ${eve} %c ${JSON.stringify(param)}`,
        `background: #996EFF; ${baseStyle}`,
        `background: green; ${baseStyle}; border-radius: 0`,
        `background: grey; ${baseStyle}`
      );
    };
  } else if (window.collectEvent) {
    window.$event = (eve, param) => {
      window.fbq && window.fbq("trackCustom", eve, param);
      window.collectEvent.call(null, eve, param);
    };
    window.$event("init", {
      app_id: 208572,
      channel: "sg",
      log: true
    });
    window.$event("start");
  } else {
    window.$event = () => {
      console.info("something is wrong !");
    };
  }
}
